import React, { FC, ReactElement, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import withLocalization from '../../components/hoc/withLocalization';
import OfferHeader from '../../components/common/OfferHeader/OfferHeader';
import { RootState } from '../../redux/rootReducer';
import PackageOfferDetails from '../../components/PackageOfferDetails/PackageOfferDetails';
import PackageBottomDetails from '../../components/PackageOfferDetails/PackageBottomDetails';
import { useMediaQuery } from 'react-responsive';
import { logAnalyticData, offerType } from '../../analytics';
import { Offer, OfferResponse } from '../../features/offerSearch/types';
import { getSiteIdentifier } from '../../util/SiteDetails';
import { useCountryCodeByDesc } from '../../util/useCountryCodeByDescription';
import { removeDecimalPart } from '../../util/CommonLogic';
import countries from 'i18n-iso-countries';
import { setOfferFlowDetails } from '../../features/OfferValidateContainer/PinOptFlowOfferSlice';
import './PinOptOfferDetailsContainer.scss';

let logAnalyticCalled = false;
const PinOptOfferDetailsContainer: FC<any> = (props: any): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });

  const prospectDetails: any = useSelector((state: RootState) => state.offerDetails.prospect);
  const prspectPhone: any = useSelector((state: RootState) => state.offerDetails.nonFormatedCallcenterNo) || '';
  const isSubmitErr = useSelector((state: RootState) => state.offerDetails.hasError);
  const pinInfoDetails: any = useSelector((state: RootState) => state.pinOptFlowDetails.pinDetails);
  const urlData: any = useSelector((state: RootState) => state.pinOptFlowDetails.urlData);
  const showCTA = useSelector((state: RootState) => state.offerDetails.showCTA);

  const offerDetails: OfferResponse = useSelector((state: RootState) => state.offerDetails.pinOptOfferDetails);
  const pin = pinInfoDetails?.pin || '';

  const offerData: Offer = (offerDetails?.offers && offerDetails.offers[0]) || '';
  const offerProperty = offerData?.property || {};
  const roomType: any = (offerData?.roomTypes && offerData?.roomTypes[0]) || {};
  const retailVal = offerData?.retailValue || '';
  const retailPrice = roomType?.highSeasonRetailPrice || '';
  const updatedRetPrice = retailPrice || retailVal;
  const splitRetVal = updatedRetPrice?.split('$') || '';
  const refineRetPrice = removeDecimalPart(splitRetVal[1]) || '';
  const depositeAmt = roomType?.depositAmount || '';
  const imgListArr: any = (offerProperty?.imgList4 && offerProperty?.imgList4[0]) || {};
  const heroImgObj: any = isMobile && imgListArr ? imgListArr['7:3'] : imgListArr['4:3'];
  const heroImg = heroImgObj?.path || imgListArr?.path || '';
  const submitError = useSelector((state: RootState) => (isSubmitErr ? state.offerDetails.error?.errorMessageKey : ''));
  const errDetails = {
    errPhNo: prspectPhone || '',
    isPkgSold: false,
    errorCode: '',
    callCenterCode: prospectDetails?.callCenterCode,
    countryName: prospectDetails?.countryCode,
  };
  const siteIdentifier = getSiteIdentifier();
  const analyliticFunc = (adobeEvent: string, adobeStepName: string, googleEvent: string) => {
    const offer: Offer = (offerDetails?.offers && offerDetails.offers[0]) || {};
    const offerCode = offer?.offerCode || 'Vacation Offer';
    const roomType = (offer?.roomTypes && offer?.roomTypes[0]) || {};
    const stateCode = roomType?.property?.stateCode;
    const destination = urlData?.destination;
    const brand = urlData?.brand && urlData?.brand.length > 0 ? urlData?.brand : roomType?.property?.brandName;
    const loc = offer?.loc || '';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: googleEvent,
      ecommerce: {
        items: [
          {
            item_id: roomType?.property?.marshaCode,
            item_name: roomType?.property?.name,
            item_brand: brand,
            item_category: destination,
            item_category2: loc,
            item_category3: roomType?.property?.country || '',
            item_category4: stateCode,
            item_category5: roomType?.property?.city,
            item_category6: '',
            item_category7: offerType(offer),
            item_category8: offerCode,
            item_catagory9: pin,
            price: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
            retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
            package_price: roomType?.startingCost?.replace(/[$,]/g, '') || '',
            flow_identifier: 'pin',
            quantity: 1,
          },
        ],
      },
    });
    logAnalyticData(
      {
        event: adobeEvent,
        siteSection: 'MVC ' + siteIdentifier + 'Optimized PBE',
        pageName: 'MVC ' + siteIdentifier + 'PBE PIN OfferPage',
        pageHierarchy: '',
        server: 'MVC',
        website: 'MVC react',
        language: 'en',
      },
      {
        errorMessage: submitError,
        offerCode: offerCode,
        offerType: offerType(offer),
        flowIdentifier: 'PIN',
        formLOC: loc,
        destination: destination,
        resortCity: roomType?.property?.city,
        resortState: roomType?.property?.stateCode,
        resortCountry: roomType?.property?.country || '',
        resortName: roomType?.property?.name,
        resortBrand: brand,
        retail_price: refineRetPrice?.replace(/[$,]/g, '') || '',
        packagePrice: roomType?.startingCost?.replace(/[$,]/g, '') || '',
        depositPrice: roomType?.depositAmount?.replace(/[$,]/g, '') || '',
        currency: 'USD',
        quanity: '1',
        resortMarsha: roomType?.property?.marshaCode,
        userSelectedState: prospectDetails?.stateProvince,
        bookingStepName: adobeStepName,
      },
    );
  };
  const countryName: any = useCountryCodeByDesc(prospectDetails?.countryCode);
  const handlePayClick = () => {
    analyliticFunc('pbePinBeginCheckout', 'MVC ' + siteIdentifier + '| PBE PIN Begin Checkout', 'begin_checkout');
  };

  const styleBg = {
    backgroundImage: `url("${heroImg}")`,
  };
  const getofferPhone: any = offerData?.offerPhoneNumber || prspectPhone;
  const phNo = getofferPhone || '';
  //const errPhNo: any = { errPhNo: prspectPhone || '' };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!offerData) {
      navigate('/pin-error', { state: errDetails });
    }
    dispatch(setOfferFlowDetails(true));
    countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
    const iso2Code = prospectDetails?.countryCode || '';
    const result = countries.alpha2ToAlpha3(iso2Code) || '';
    sessionStorage.setItem('iso3Code', result);
    sessionStorage.setItem('countryFullName', countryName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (isSubmitErr || showCTA) {
      navigate('/pin-error', { state: errDetails });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitErr, showCTA]);
  useEffect(() => {
    if (!logAnalyticCalled) {
      analyliticFunc('pbePinOfferPage', 'MVC ' + siteIdentifier + '| PBE PIN Offer Page', 'view_item');
      logAnalyticCalled = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <OfferHeader phone={phNo} isThankyou={false} />
      <div className="tmvc-offer-main-container">
        {!isMobile && (
          <>
            <div className="heroImg-container" style={styleBg}>
              <PackageOfferDetails
                offersData={offerData}
                leadDetails={prospectDetails}
                handlePayClick={handlePayClick}
              />
            </div>
            <PackageBottomDetails offersData={offerData} depositeAmt={depositeAmt} />
          </>
        )}
        {isMobile && (
          <>
            <img src={heroImg} alt="main" className="pinFlowPkg-Img" />
            <PackageOfferDetails offersData={offerData} leadDetails={prospectDetails} handlePayClick={handlePayClick} />
            <PackageBottomDetails offersData={offerData} depositeAmt={depositeAmt} />
          </>
        )}
      </div>
    </>
  );
};
export default withLocalization(PinOptOfferDetailsContainer);
